/*
 * @Auther: 罗耀祖
 * @Date: 2022-03-30 17:16:46
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-31 15:05:25
 * @name: 权限模块api
 * @Description: 权限模块api
 * @FilePath: \preSaleNafterSaleBackstage\src\api\admin_role\admin_role.api.js
 * @Author: desktop
 */
import apiAdd from "../apiAdd.js";
import apiEdit from "../apiEdit.js";
import apiDelete from "../apiDelete.js";
import apiSearch from "../apiSearch.js";
import axios from 'axios';
import { Message } from "element-ui";

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取角色列表(分页)
 */
export const adminRoleGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/admin_role/getList.html', data, instance);
}

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取角色列表(全部)
 */
export const adminRoleGetAllList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/admin_role/getAllList.html', data, instance);
}

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取角色信息
 */
 export const adminRoleDetail = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/admin_role/detail.html', data, instance);
}

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取权限列表
 */
export const adminRoleAuthList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/admin_role/authList.html', data, instance);
}

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 添加角色
 */
export const adminRoleAdd = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.post('/admin/admin_role/add.html', data, instance);
}

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 编辑角色
 */
export const adminRoleEdit = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.post('/admin/admin_role/edit.html', data, instance);
}

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 删除角色
 */
export const adminRoleDelete = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.post('/admin/admin_role/delete.html', data, instance);
}